import { sessionManager } from "core/instances";
import BaseService from "./base.service";
import { UserActivityLogger } from "./user-tracking-helper";

class BaseServiceWithUserTracking extends BaseService {
    userTracking: UserActivityLogger;

    constructor(trackingArea: string) {
        super();

        this.userTracking = new UserActivityLogger(trackingArea);
    }

    protected getRequestHeaders() {
        const headers = super.getRequestHeaders();

        //Note the point of the x-user header is for user tracking at the Utility Service controller level
        headers["x-user"] = sessionManager.getUserDetailsForHeader();

        return headers;
    }
}

export default BaseServiceWithUserTracking;
